import React from "react";
import { useSelector } from "react-redux";
import {
  eCalculatorTab,
  eIncluded,
  eProduct,
  getProductName,
} from "../../services/helpers/udmConstants";
import CIDetails from "./CIDetails";
import { Divider } from "../../assets/appStyledComponents";
import IrResultWrapper from "./IrResultWrapper";

function IrCIResultSection() {
  const PageData = useSelector((state) => state.irCalculatorReducer?.data);
  const currTabData = PageData?.result?.[eCalculatorTab.criticalIllness];
  const youPolicy = currTabData?.illustration?.policy.filter(
    (obj) =>
      obj.product === getProductName(eProduct.LC) &&
      obj.coverage[0].partyId === `Life.1`
  );
  const partnerPolicy = currTabData?.illustration?.policy.filter(
    (obj) =>
      obj.product === getProductName(eProduct.LC) &&
      obj.coverage[0].partyId === `Life.2`
  );
  return (
    <IrResultWrapper>
      <CIDetails
        name={PageData?.step1?.you?.irName}
        insuranceAmount={
          youPolicy && youPolicy[0]?.coverage[0]?.amount
            ? youPolicy[0]?.coverage[0]?.amount
            : "0.00"
        }
        costAmount={
          youPolicy && youPolicy[0]?.minimumModalPremium
            ? youPolicy[0]?.minimumModalPremium
            : "0.00"
        }
        age={PageData?.step1?.you?.irAge}
      />
      {PageData?.step1?.irInsuranceFor === eIncluded.meAndPartner && (
        <>
          <Divider />
          <CIDetails
            name={PageData?.step1?.partner?.irName}
            insuranceAmount={
              partnerPolicy && partnerPolicy[0]?.coverage[0]?.amount
                ? partnerPolicy[0]?.coverage[0]?.amount
                : "0.00"
            }
            costAmount={
              partnerPolicy && partnerPolicy[0]?.minimumModalPremium
                ? partnerPolicy[0]?.minimumModalPremium
                : "0.00"
            }
            age={PageData?.step1?.partner?.irAge}
          />
        </>
      )}
    </IrResultWrapper>
  );
}

export default IrCIResultSection;
